export const testModuleChiTietMenuI18n = {
  testModuleChiTiet: 'TEST MODULE',
  testModuleChiTietPage: {
    title: '模块明细 TEST',
    description:
      '各模块：Test UI 实屏操作。订单组另有「创建数据」按钮（默认 5 条，数量可改）。',
  },
} as const
